import { Component } from "react";
import {Link} from 'react-router-dom';
import logo from './logo.jpeg';

class Header extends Component{
    constructor(props){

        super (props)

    }
    componentDidMount(){
      if(localStorage.getItem("isAuth") == "true"){
      }else{window.location.pathname = '/BMS'}
    }
    logout(){
      localStorage.clear();
      window.location.pathname = '/BMS'
    }
    
    render(){
      if(localStorage.getItem("isAuth") == "true"){ 
        if(localStorage.getItem("ROLE") == "Admin"){
          return(

            <div className="header-container">
            <header className="header navbar navbar-expand-sm">
              <a className="sidebarCollapse" data-placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1={3} y1={12} x2={21} y2={12} /><line x1={3} y1={6} x2={21} y2={6} /><line x1={3} y1={18} x2={21} y2={18} /></svg></a>
              <div className="nav-logo align-self-center">
                <a className="navbar-brand" href="/BMS"><img alt="logo" src={logo} /> <span className="navbar-brand-name"> </span></a>
              </div>
              <ul className="navbar-item topbar-navigation">
                {/*  BEGIN TOPBAR  */}
                <div className="topbar-nav header navbar" role="banner">
                  <nav id="topbar">
                    <ul className="navbar-nav theme-brand flex-row  text-center">
                      <li className="nav-item theme-logo">
                        <a href="index.html">
                          <img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" className="navbar-logo" alt="logo" />
                        </a>
                      </li>
                      <li className="nav-item theme-text">
                        <a href="#" className="nav-link"> BMS </a>
                      </li>
                    </ul>
                    <ul className="list-unstyled menu-categories" id="topAccordion">
                    
                   
                      <li className="menu single-menu active">
                        <a href="#dashboard" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle autodroprown">
                          <div className>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-home shadow-icons"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
                            <span> <Link to="/BMS/dashboard" > Dashboard </Link> </span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        {/* <ul className="collapse submenu list-unstyled animated fadeInUp" id="dashboard" data-parent="#topAccordion">
                          <li className="active">
                            <a href="index.html"> Sales </a>
                          </li>
                          <li>
                            <a href="index2.html"> Analytics </a>
                          </li>
                        </ul> */}
                      </li>
                      <li className="menu single-menu">
                        <a href="#app" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                          <svg xmlns="http://www.w3.org/2000/svg"  width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} stroke-linecap="round" stroke-linejoin="round" class="feather feather-users"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx={9} cy={7} r={4}></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                          <span>Users</span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="app" data-parent="#topAccordion">
                          <li>
                          <Link to="/BMS/create-user" > Add Users </Link> 
                          </li>
                          <li>
                          <Link to="/BMS/view-users" > View Users </Link> 
                            {/* <a href="apps_mailbox.html"> View Users</a> */}
                          </li>                             
                        </ul>
                      </li>
                      <li className="menu single-menu">
                        <a href="#components" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1={12} y1="22.08" x2={12} y2={12} /></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-box shadow-icons"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1={12} y1="22.08" x2={12} y2={12} /></svg>
                            <span>Bids</span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="components" data-parent="#topAccordion">
                         
                          <li>
                          <Link to="/BMS/add-bids" > Add Bids </Link> 
                          </li>
                          <li>
                          <Link to="/BMS/view-bids" > View Bids </Link> 
                          
                          </li>
                          
                        </ul>
                      </li>
                      {/* <li className="menu single-menu">
                        <a href="#tables" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-layout"><rect x={3} y={3} width={18} height={18} rx={2} ry={2} /><line x1={3} y1={9} x2={21} y2={9} /><line x1={9} y1={21} x2={9} y2={9} /></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-layout shadow-icons"><rect x={3} y={3} width={18} height={18} rx={2} ry={2} /><line x1={3} y1={9} x2={21} y2={9} /><line x1={9} y1={21} x2={9} y2={9} /></svg>
                            <span>Tables</span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="tables" data-parent="#topAccordion">
                          <li>
                            <a href="table_basic.html"> Basic </a>
                          </li>
                          <li className="sub-sub-submenu-list">
                            <a href="#datatable" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> DataTables <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                            <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="datatable" data-parent="#datatable">
                              <li>
                                <a href="table_dt_basic.html"> Basic </a>
                              </li>
                              <li>
                                <a href="table_dt_ordering_sorting.html"> Order Sorting </a>
                              </li>
                              <li>
                                <a href="table_dt_multi-column_ordering.html"> Multi-Column </a>
                              </li>
                              <li>
                                <a href="table_dt_multiple_tables.html"> Multiple Tables</a>
                              </li>
                              <li>
                                <a href="table_dt_alternative_pagination.html"> Alt. Pagination</a>
                              </li>
                              <li>
                                <a href="table_dt_custom.html"> Custom </a>
                              </li>
                              <li>
                                <a href="table_dt_range_search.html"> Range Search </a>
                              </li>
                              <li>
                                <a href="table_dt_html5.html"> HTML5 Export </a>
                              </li>
                              <li>
                                <a href="table_dt_live_dom_ordering.html"> Live DOM ordering </a>
                              </li>
                              <li>
                                <a href="table_dt_miscellaneous.html"> Miscellaneous </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="menu single-menu">
                        <a href="#forms" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x={8} y={2} width={8} height={4} rx={1} ry={1} /></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-clipboard shadow-icons"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x={8} y={2} width={8} height={4} rx={1} ry={1} /></svg>
                            <span>Forms</span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="forms" data-parent="#topAccordion">
                          <li>
                            <a href="form_bootstrap_basic.html"> Basic </a>
                          </li>
                          <li>
                            <a href="form_input_group_basic.html"> Input Group </a>
                          </li>
                          <li>
                            <a href="form_layouts.html"> Layouts </a>
                          </li>
                          <li>
                            <a href="form_validation.html"> Validation </a>
                          </li>
                          <li>
                            <a href="form_input_mask.html"> Input Mask </a>
                          </li>
                          <li>
                            <a href="form_bootstrap_select.html"> Bootstrap Select </a>
                          </li>
                          <li>
                            <a href="form_select2.html"> Select2 </a>
                          </li>
                          <li>
                            <a href="form_bootstrap_touchspin.html"> TouchSpin </a>
                          </li>
                          <li>
                            <a href="form_maxlength.html"> Maxlength </a>
                          </li>
                          <li>
                            <a href="form_checkbox_radio.html"> Checkbox &amp; Radio </a>
                          </li>
                          <li>
                            <a href="form_switches.html"> Switches </a>
                          </li>
                          <li>
                            <a href="form_wizard.html"> Wizards </a>
                          </li>
                          <li>
                            <a href="form_fileupload.html"> File Upload </a>
                          </li>
                          <li>
                            <a href="form_quill.html"> Quill Editor </a>
                          </li>
                          <li>
                            <a href="form_markdown.html"> Markdown Editor </a>
                          </li>
                          <li>
                            <a href="form_date_range_picker.html"> Date &amp; Range Picker </a>
                          </li>
                          <li>
                            <a href="form_clipboard.html"> Clipboard </a>
                          </li>
                          <li>
                            <a href="form_typeahead.html"> Typeahead </a>
                          </li>
                        </ul>
                      </li>
                      <li className="menu single-menu menu-extras">
                        <a href="#more" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                            <span><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-more-horizontal"><circle cx={12} cy={12} r={1} /><circle cx={19} cy={12} r={1} /><circle cx={5} cy={12} r={1} /></svg> <span className="d-xl-none">More</span></span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="more" data-parent="#topAccordion">
                          <li className="sub-sub-submenu-list">
                            <a href="#page" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Pages <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                            <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="page" data-parent="#more">
                              <li>
                                <a href="pages_helpdesk.html"> Helpdesk </a>
                              </li>
                              <li>
                                <a href="pages_contact_us.html"> Contact Form </a>
                              </li>
                              <li>
                                <a href="pages_faq.html"> FAQ </a>
                              </li>
                              <li>
                                <a href="pages_faq2.html"> FAQ 2 </a>
                              </li>
                              <li>
                                <a href="pages_privacy.html"> Privacy Policy </a>
                              </li>
                              <li>
                                <a href="pages_coming_soon.html"> Coming Soon </a>
                              </li>
                              <li>
                                <a href="user_profile.html"> Profile </a>
                              </li>
                              <li>
                                <a href="user_account_setting.html"> Account Settings </a>
                              </li>
                              <li className="sub-sub-submenu-list">
                                <a href="#pages-error" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Error <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                                <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="pages-error" data-parent="#page"> 
                                  <li>
                                    <a href="pages_error404.html"> 404 </a>
                                  </li>
                                  <li>
                                    <a href="pages_error500.html"> 500 </a>
                                  </li>
                                  <li>
                                    <a href="pages_error503.html"> 503 </a>
                                  </li>
                                  <li>
                                    <a href="pages_maintenence.html"> Maintanence </a>
                                  </li>
                                </ul>
                              </li>
                              <li className="sub-sub-submenu-list">
                                <a href="#user-login" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Login <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                                <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="user-login" data-parent="#page"> 
                                  <li>
                                    <a href="auth_login.html"> Login </a>
                                  </li>
                                  <li>
                                    <a href="auth_login_boxed.html"> Login Boxed </a>
                                  </li>
                                </ul>
                              </li>
                              <li className="sub-sub-submenu-list">
                                <a href="#user-register" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Register <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                                <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="user-register" data-parent="#page"> 
                                  <li>
                                    <a href="auth_register.html"> Register </a>
                                  </li>
                                  <li>
                                    <a href="auth_register_boxed.html"> Register Boxed </a>
                                  </li>
                                </ul>
                              </li>
                              <li className="sub-sub-submenu-list">
                                <a href="#user-passRecovery" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Password Recovery <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                                <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="user-passRecovery" data-parent="#page"> 
                                  <li>
                                    <a href="auth_pass_recovery.html"> Recover ID </a>
                                  </li>
                                  <li>
                                    <a href="auth_pass_recovery_boxed.html"> Recover ID Boxed </a>
                                  </li>
                                </ul>
                              </li>
                              <li className="sub-sub-submenu-list">
                                <a href="#user-lockscreen" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Lockscreen <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                                <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="user-lockscreen" data-parent="#page"> 
                                  <li>
                                    <a href="auth_lockscreen.html"> Unlock </a>
                                  </li>
                                  <li>
                                    <a href="auth_lockscreen_boxed.html"> Unlock Boxed </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="dragndrop_dragula.html"> Drag and Drop</a>
                          </li>
                          <li>
                            <a href="widgets.html"> Widgets </a>
                          </li>
                          <li>
                            <a href="map_jvector.html"> Vector Maps</a>
                          </li>
                          <li>
                            <a href="charts_apex.html"> Charts </a>
                          </li>
                          <li>
                            <a href="fonticons.html"> Font Icons </a>
                          </li>
                          <li className="sub-sub-submenu-list">
                            <a href="#starter-kit" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle"> Starter Kit <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6" /></svg> </a>
                            <ul className="collapse list-unstyled sub-submenu animated fadeInUp" id="starter-kit" data-parent="#more">
                              <li>
                                <a href="starter_kit_blank_page.html"> Blank Page </a>
                              </li>
                              <li>
                                <a href="starter_kit_boxed.html"> Boxed </a>
                              </li>
                              <li>
                                <a href="starter_kit_breadcrumb.html"> Breadcrumb </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="../../documentation/index.html"> Documentation </a>
                          </li>
                        </ul>
                      </li> */}
                    </ul>
                  </nav>
                </div>
                {/*  END TOPBAR  */}
              </ul>
              <ul className="navbar-item flex-row ml-auto">
                {/* <li className="nav-item align-self-center search-animated">
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-search toggle-search"><circle cx={11} cy={11} r={8} /><line x1={21} y1={21} x2="16.65" y2="16.65" /></svg>
                  <form className="form-inline search-full form-inline search" role="search">
                    <div className="search-bar">
                      <input type="text" className="form-control search-form-control  ml-lg-auto" placeholder="Search..." />
                    </div>
                  </form>
                </li> */}
              </ul>
              <ul className="navbar-item flex-row nav-dropdowns">
                {/* <li className="nav-item dropdown language-dropdown more-dropdown">
                  <div className="dropdown custom-dropdown-icon">
                    <a className="dropdown-toggle btn" href="#" role="button" id="customDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="assets/img/ca.png" className="flag-width" alt="flag" />
                      */}
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg> */}
                    
                    {/* </a>
                    <div className="dropdown-menu dropdown-menu-right animated fadeInUp" aria-labelledby="customDropdown">
                      <div className="search-dropdown">
                        <input type="text" className="form-control" placeholder="Search" />
                      </div>
                      <a className="dropdown-item" data-img-value="de" data-value="de" href="javascript:void(0);"><img src="assets/img/de.png" className="flag-width" alt="flag" /> German</a>
                      <a className="dropdown-item" data-img-value="jp" data-value="jp" href="javascript:void(0);"><img src="assets/img/jp.png" className="flag-width" alt="flag" /> Japanese</a>
                      <a className="dropdown-item" data-img-value="fr" data-value="fr" href="javascript:void(0);"><img src="assets/img/fr.png" className="flag-width" alt="flag" /> French</a>
                      <a className="dropdown-item" data-img-value="ca" data-value="en" href="javascript:void(0);"><img src="assets/img/ca.png" className="flag-width" alt="flag" /> English</a>
                    </div>
                  </div>
                </li> */}

                <li className="nav-item dropdown message-dropdown" onClick={()=>this.logout()}>
                  <a href="javascript:void(0);" className="nav-link dropdown-toggle" id="messageDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1={21} y1={12} x2={9} y2={12} /></svg> <span>Log Out</span>
                     
                  </a>
                 
                </li>
                 
               
              </ul>
            </header>
          </div>
        );
        }else{
           return(

            <div className="header-container">
            <header className="header navbar navbar-expand-sm">
              <a className="sidebarCollapse" data-placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1={3} y1={12} x2={21} y2={12} /><line x1={3} y1={6} x2={21} y2={6} /><line x1={3} y1={18} x2={21} y2={18} /></svg></a>
              <div className="nav-logo align-self-center">
                <a className="navbar-brand" href="/BMS"><img alt="logo" src={logo} /> <span className="navbar-brand-name"> </span></a>
              </div>
              <ul className="navbar-item topbar-navigation">
                {/*  BEGIN TOPBAR  */}
                <div className="topbar-nav header navbar" role="banner">
                  <nav id="topbar">
                    <ul className="navbar-nav theme-brand flex-row  text-center">
                      <li className="nav-item theme-logo">
                        <a href="/BMS">
                          <img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" className="navbar-logo" alt="logo" />
                        </a>
                      </li>
                      <li className="nav-item theme-text">
                        <a href="#" className="nav-link"> BMS </a>
                      </li>
                    </ul>
                    <ul className="list-unstyled menu-categories" id="topAccordion">
                    
                   
                      <li className="menu single-menu active">
                        <a href="#dashboard" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle autodroprown">
                           
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                         
                      </li>
                      <li className="menu single-menu">
                        <a href="#app" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                           
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="app" data-parent="#topAccordion">
                          <li>
                          
                          </li>
                          <li>
                          
                          
                          </li>                             
                        </ul>
                      </li>
                      <li className="menu single-menu">
                        <a href="#components" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                          <div className>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1={12} y1="22.08" x2={12} y2={12} /></svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-box shadow-icons"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1={12} y1="22.08" x2={12} y2={12} /></svg>
                            <span>Bids</span>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg>
                        </a>
                        <ul className="collapse submenu list-unstyled animated fadeInUp" id="components" data-parent="#topAccordion">
                         
                         <li>
                         <Link to="/BMS/add-bids" > Add Bids </Link> 
                         </li>
                         <li>
                         <Link to="/BMS/view-bids" > View Bids </Link> 
                         
                         </li>
                         
                       </ul>
                      </li>
                     
                    </ul>
                  </nav>
                </div>
                {/*  END TOPBAR  */}
              </ul>
              <ul className="navbar-item flex-row ml-auto">
                
              </ul>
              <ul className="navbar-item flex-row nav-dropdowns">
              
                <li className="nav-item dropdown message-dropdown" onClick={()=>this.logout()}>
                  <a href="javascript:void(0);" className="nav-link dropdown-toggle" id="messageDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1={21} y1={12} x2={9} y2={12} /></svg> <span>Log Out</span>
                     
                  </a>
                 
                </li>
                 
               
              </ul>
            </header>
          </div>
        );
        }
       
    
        }else{window.location.pathname = '/'}
    };

}
export default Header;